module.exports = __webpack_public_path__ + "img/screen.a0584432.png";